import classes from './Home.module.css';
import video1 from '../../Designs/video1.webm';
import MultiCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {Link} from 'react-router-dom';
import aire from '../../Designs/SectionDesigns/TechnicalSection/Icons/aire.png';
import camara from '../../Designs/SectionDesigns/TechnicalSection/Icons/camara.png';
import correctivo from '../../Designs/SectionDesigns/TechnicalSection/Icons/correctivo.png';
import cortina from '../../Designs/SectionDesigns/TechnicalSection/Icons/cortina.png';
import lampara from '../../Designs/SectionDesigns/TechnicalSection/Icons/lampara.png';
import preventivo from '../../Designs/SectionDesigns/TechnicalSection/Icons/preventivo.png';
import tablero from '../../Designs/SectionDesigns/TechnicalSection/Icons/tablero.png';
import aireBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/aireBackground.png';
import cameraBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/cameraBackground.png';
import correctivoBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/correctivoBackground.png';
import curtainBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/curtainBackground.png';
import lamparaBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/lamparaBackground.png';
import preventivoBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/preventivoBackground.png';
import tableroBackground from '../../Designs/SectionDesigns/TechnicalSection/Background/tableroBackground.png';
import Carousel from 'react-bootstrap/Carousel';
import slide1 from '../../Designs/SectionDesigns/Introduction/Slides/slide1.png';
import slide2 from '../../Designs/SectionDesigns/Introduction/Slides/slide2.png';
import slide3 from '../../Designs/SectionDesigns/Introduction/Slides/slide3.png';
import slide4 from '../../Designs/SectionDesigns/Introduction/Slides/slide4.png';
import {useState} from 'react';
import TextField from '@mui/material/TextField';
import {styled}  from '@mui/system';
import rightArrow from '../../Designs/SectionDesigns/ContactForm/Icons/right-arrow.png';
import EastIcon from '@mui/icons-material/East';
import {useForm} from 'react-hook-form';
import { useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';

const Home = ({services}) => {

	useEffect(() => {
        document.querySelector("nav").style.display = "grid";
	})

	const [showSuccess, setShowSuccess] = useState(false);
	const [showFailure, setShowFailure] = useState(true);
	const {register, handleSubmit, error, formState: { errors }} = useForm();
	const [moveArrow, setMoveArrow] = useState(false);
	const responsive = {
		other: {
			breakpoint: {max: 5000, min:1400},
			items: 4,
		},
		normal: {
			breakpoint: {max: 1500, min: 1100},
			items: 3
		},
		desktop: {
			breakpoint: {max: 1100, min: 700},
			items: 2,
		},
		mobile: {
			breakpoint: {max: 700, min: 0},
			items: 1,
		}
	};

	const arrow = {
	  	color: '#2c2524',
	  	fontSize: '30px',
  	}

  	const icons = [
  				   aire, //
  				   camara, //
  				   correctivo, //
  				   cortina,
  				   lampara, //
  				   preventivo, //
  				   tablero //
				  ]
		const backgroundSections = [
			aireBackground,
			cameraBackground,
			correctivoBackground,
			curtainBackground,
			lamparaBackground,
			preventivoBackground,
			tableroBackground
		]

		const slides = [slide1, slide2, slide3, slide4];

		const [flip, setFlip] = useState(icons.reduce((curr, icon) => {

			return {
				...curr,
				[icon]: false
			};
		}, {}));

		const ContactField = styled(TextField)({
			width: '50%',
		})

		const contactSubmit = data => {
			const {email, message, name, number} = data;
			fetch("https://rjknack-server.herokuapp.com/mail", {
				method: 'POST',
				redirects: "follows",
				body: JSON.stringify({
					name,
					number,
			    mail: email,
			    msg: message,
				}),
				headers: {
					"Content-Type": "application/json"
				}
			}).then((resp) => resp.json()).then((answer) => {
				if (answer) {
					if (!showSuccess) {
						setShowSuccess(true);
						setTimeout(() => {
							setShowSuccess(false);
						}, 4000)
					}
				}
			})
		}


	return (
		<>
			<video src={video1} style={{
				objectFit: 'cover',
				height: '100%',
				width: '100%',
				zIndex:'1',
				position: 'fixed',
			}} autoPlay={true} muted loop/>
			<div className={classes.outer}>
				<div className={classes.servicios}>
					<div>
						<h2>Servicios Tecnicos</h2>
						<h6>Hello World Hell World</h6>
					</div>
					<MultiCarousel
							draggable={false}
							autoPlay={true}
							infinite={true}
							containerClass={`react-multi-carousel-list ${classes.carousel_servicioTecnico}`}
							responsive={responsive}>
							{
								Object.entries(services).map(([service, link], index) =>
									<div className={classes.servicioTecnico}>
										<Link to={link} onMouseOver={()=>{
												setFlip({
													...flip,
													[service]:true
												});
											}} onMouseOut={()=>{
												setFlip({
													...flip,
													[service]:false
												});
											}}>
											<span className={`${flip[service] ? "flip-card" : ""}`}>
												<img src={icons[index]}/>
											</span>
											<img src={backgroundSections[index]}/>
										</Link>
										<Link to={link}>{service}</Link>
									</div>
								)
							}
					</MultiCarousel>
				</div>
				<div className={classes.introduction}>
					<div>
						<h3>Introduction - Presentation</h3>
						<p>Paragraph Lorem Ipsum</p>
					</div>
					<Carousel pause={false}
										indicators={false}
										fade={true}
										interval={3000}
										className={classes.introductionCarousel}
										controls={false}>
						{
							slides.map(( image, index ) => {
								return <Carousel.Item key={index} className={classes.introductionImageContainer}>
									<img src={image}/>
								</Carousel.Item>
							})
						}
					</Carousel>
				</div>
				<div className={classes.projectsContainer}>
					<h3>Nuestros Proyectos Realizados</h3>
					<div className={classes.projects}>
						<img src={slide1}/>
						<img src={slide1}/>
						<img src={slide1}/>
						<img src={slide1}/>
						<img src={slide1}/>
						<img src={slide1}/>
					</div>
				</div>
				<form className={classes.contactForm} onSubmit={handleSubmit(contactSubmit)}>
					<div>
						<h2>CONTACT US</h2>
						<p>LoremIpsum</p>
					</div>
					<div className={`${showSuccess ? 'success show-success' : 'success'} `}>
						<CheckIcon sx={{
								color: '#3274BA',
								fontSize: '32px'
							}}/>
						<p>Hemos recibido su mensaje y pronto nos comunicaremos con usted.</p>
					</div>
					<input
						placeholder={"Nombre"}
						type={"name"}
						{...register("name", {
							required: true
						})}/>
					<input
						placeholder={"Numero de Telefono"}
						type={"text"}
						{...register("number", {
							required: true,
							maxLength: 12,
							minLength: 9,
						})}/>
					<input
						placeholder={"Correo Electronico"}
						type={"email"}
						{...register("email", {
							required: true
						})}/>
					<input placeholder={"Mensaje"}
						type={"text"}
						{...register("message", {
							required: true,
							minLength: 5
						})}/>
					<button onMouseOver={()=>{setMoveArrow(true)}}
						type={"submit"}
						onMouseOut={()=>{setMoveArrow(false)}}>
						<h4>Submit</h4>
						<EastIcon sx={{
								color: 'white',
								transition: 'all 0.5s'
							}} className={`${moveArrow ? 'move-arrow' : ''}`}/>
					</button>
				</form>

			</div>
		</>
	);
};

export default Home;
